import React, { useContext } from 'react';
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
import { StepsContext } from '../../context/stepsContext';
import CheckIcon from '@mui/icons-material/Check';
export default function Steps({ step, active, er }) {
  const { step: allStep } = useContext(StepsContext);
  // console.log(allStep);
  // console.log(step);
  // console.log(active);

  return (
    <div className="stepsContainer xs:!px-2">
      <div className="stepsTop">
        <div className="lineContainer"></div>
        <div className="circlesContainer">
          <div style={{ flex: '0.6' }}>
            <span>
              {(step === 1 || allStep > 0) && (
                <div>
                  {allStep > 0 ? (
                    <CheckIcon
                      sx={{ width: '100%', height: '100%', color: '#2497a6' }}
                    />
                  ) : (
                    <EmojiEmotionsIcon
                      sx={{ width: '100%', height: '100%', color: '#FFC962' }}
                    />
                  )}
                </div>
              )}
            </span>
          </div>
          <div>
            <div>
              <span>
                {(step === 2 || allStep > 1) && (
                  <div>
                    {allStep > 1 ? (
                      <CheckIcon
                        sx={{ width: '100%', height: '100%', color: '#2497a6' }}
                      />
                    ) : (
                      <EmojiEmotionsIcon
                        sx={{ width: '100%', height: '100%', color: '#FFC962' }}
                      />
                    )}
                  </div>
                )}
              </span>
              <span>
                {(step === 22 || allStep > 2) && (
                  <div>
                    {allStep > 2 ? (
                      <CheckIcon
                        sx={{ width: '100%', height: '100%', color: '#2497a6' }}
                      />
                    ) : (
                      <EmojiEmotionsIcon
                        sx={{ width: '100%', height: '100%', color: '#FFC962' }}
                      />
                    )}
                  </div>
                )}
              </span>
            </div>
          </div>
          <div>
            <div>
              <span>
                {(step === 3 || allStep > 3) && (
                  <div>
                    {allStep > 3 ? (
                      <CheckIcon
                        sx={{ width: '100%', height: '100%', color: '#2497a6' }}
                      />
                    ) : (
                      <EmojiEmotionsIcon
                        sx={{ width: '100%', height: '100%', color: '#FFC962' }}
                      />
                    )}
                  </div>
                )}
              </span>
              <span>
                {(step === 33 || allStep > 4) && (
                  <div>
                    {allStep > 4 ? (
                      <CheckIcon
                        sx={{ width: '100%', height: '100%', color: '#2497a6' }}
                      />
                    ) : (
                      <EmojiEmotionsIcon
                        sx={{ width: '100%', height: '100%', color: '#FFC962' }}
                      />
                    )}
                  </div>
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="steps-text-container">
        <div className="steps-text xs:!w-full">
          <div className={active && step === 1 ? 'active-s' : 'active-n'}>
            {er ? 'Your Experience' : 'Wellbeing Experience'}
          </div>
          <div
            className={
              active && (step === 2 || step === 22) ? 'active-s' : 'active-n'
            }
          >
            {er ? 'Your Challenges' : 'Wellbeing Challenges'}
          </div>
          <div
            className={
              active && (step === 3 || step === 32 || step === 33)
                ? 'active-s'
                : 'active-n'
            }
          >
            {er ? 'Wellbeing Support' : 'Wellbeing Support'}
          </div>
        </div>
      </div>
    </div>
  );
}
